import React from 'react'
import { Link } from 'react-router-dom'

const Checkout = () => {
    return (
        <>
            <section id="checkout" className="checkout-main-block">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="checkout-block">
                                <h4 className="checkout-title">Contact information</h4>
                                <p>
                                    We'll use this email to send you details and updates about your
                                    order.
                                </p>
                                <div className="form-floating mb-3">
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="floatingEmail"
                                        placeholder="Email address"
                                    />
                                    <label htmlFor="floatingEmail">Email address</label>
                                </div>
                            </div>
                            <div className="checkout-block">
                                <h4 className="checkout-title">Billing address</h4>
                                <p>Enter the billing address that matches your payment method.</p>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="form-floating mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="floatingFirstName"
                                                placeholder="First name"
                                            />
                                            <label htmlFor="floatingFirstName">First name</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-floating mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="floatingLastName"
                                                placeholder="Last name"
                                            />
                                            <label htmlFor="floatingLastName">Last name</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-floating mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="floatingAddress"
                                                placeholder="Address"
                                            />
                                            <label htmlFor="floatingAddress">Address</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-floating mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="floatingAddress1"
                                                placeholder="Apartment, suite, etc. (optional)"
                                            />
                                            <label htmlFor="floatingAddress1">
                                                Apartment, suite, etc. (optional)
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-floating mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="floatingCountry"
                                                placeholder="Country/Region"
                                            />
                                            <label htmlFor="floatingCountry">Country/Region</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-floating mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="floatingCity"
                                                placeholder="City"
                                            />
                                            <label htmlFor="floatingCity">City</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-floating mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="floatingState"
                                                placeholder="State"
                                            />
                                            <label htmlFor="floatingState">State</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-floating mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="floatingZip"
                                                placeholder="ZIP Code"
                                            />
                                            <label htmlFor="floatingZip">ZIP Code</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-floating mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="floatingPhone"
                                                placeholder="Phone (optional)"
                                            />
                                            <label htmlFor="floatingPhone">Phone (optional)</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="checkout-block">
                                <h4 className="checkout-title">Payment options</h4>
                                <div className="checkout-form-check-block">
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="paymentMethod"
                                            id="bankTransfer"
                                            defaultChecked=""
                                        />
                                        <label className="form-check-label" htmlFor="bankTransfer">
                                            Direct bank transfer
                                        </label>
                                        <p>
                                            Make your payment directly into our bank account. Please use
                                            your Order ID as the payment reference. Your order will not be
                                            shipped until the funds have cleared in our account.
                                        </p>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="paymentMethod"
                                            id="checkPayments"
                                        />
                                        <label className="form-check-label" htmlFor="checkPayments">
                                            Check payments
                                        </label>
                                    </div>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="paymentMethod"
                                            id="cashOnDelivery"
                                        />
                                        <label className="form-check-label" htmlFor="cashOnDelivery">
                                            Cash on delivery
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className="checkout-block">
                                <div className="form-check checkout-checkbox-block">
                                    <input className="form-check-input" type="checkbox" id="addNote" />
                                    <label className="form-check-label" htmlFor="addNote">
                                        Add a note to your order
                                    </label>
                                    <p>
                                        By proceeding with your purchase you agree to our Terms and
                                        Conditions and Privacy Policy
                                    </p>
                                </div>
                            </div>
                            <div className="checkout-block-button">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-6">
                                        <Link
                                            to="/Cart"
                                            title="reset"
                                            className="btn btn-secondary return"
                                        >
                                            <i className="flaticon-left-arrow" />
                                            Return to Cart
                                        </Link>
                                    </div>
                                    <div className="col-lg-8 col-md-8 col-6 text-end">
                                        <button type="submit" className="btn btn-primary order">
                                            Place Order
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 offset-lg-1">
                            <div className="cart-order-summary">
                                <div className="order-block">
                                    <h4 className="cart-order-title">Order summary</h4>
                                    <div className="row">
                                        <div className="col-lg-2 col-md-2 col-2">
                                            <div className="cart-order-img">
                                                <Link to="#" title="">
                                                    <img
                                                        src="assets/images/contact-info/01.png"
                                                        className="img-fluid"
                                                        alt=""
                                                    />
                                                </Link>
                                                <span className="badge text-bg-secondary">1</span>
                                            </div>
                                        </div>
                                        <div className="col-lg-10 col-md-10 col-10">
                                            <div className="row">
                                                <div className="col-lg-8 col-md-8 col-8">
                                                    <h6 className="order-title">
                                                        <Link to="#" title="">
                                                            Racking Chair
                                                        </Link>
                                                    </h6>
                                                    <div className="rate">$39.90</div>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-4">
                                                    <div className="price text-end">$39.90</div>
                                                </div>
                                            </div>
                                            <p>
                                                Cras mattis consectetur purus sit amet fermentum. Lorem ipsum
                                                dolor sit amet, consectetur adipiscing elit…
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="coupon">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        data-bs-toggle="modal"
                                        data-bs-target="#couponModal"
                                    >
                                        Add a coupon
                                    </button>
                                    {/* Modal */}
                                    <div
                                        className="modal fade"
                                        id="couponModal"
                                        
                                        aria-labelledby="couponModalLabel"
                                        aria-hidden="true"
                                    >
                                        <div className="modal-dialog">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h1 className="modal-title fs-5" id="exampleModalLabel">
                                                        Coupon
                                                    </h1>
                                                    <button
                                                        type="button"
                                                        className="btn-close"
                                                        data-bs-dismiss="modal"
                                                        aria-label="Close"
                                                    />
                                                </div>
                                                <div className="modal-body">
                                                    <form>
                                                        <div className="form-floating mb-3">
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                id="floatingCoupon"
                                                                placeholder="Coupon"
                                                            />
                                                            <label htmlFor="floatingCoupon">Code</label>
                                                        </div>
                                                    </form>
                                                </div>
                                                <div className="modal-footer">
                                                    <button type="button" className="btn btn-primary">
                                                        Apply
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="subtotal-block">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6 col-6">
                                            <h4 className="cart-order-title">Subtotal</h4>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-6">
                                            <div className="price text-end">$39.90</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="total-block">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6 col-6">
                                            <div className="total">Total</div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-6">
                                            <div className="amount text-end">$39.90</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Checkout
